import MarkdownContent from "features/markdown/elements/MarkdownContent";
import React, { useState } from "react";
import InfoButton from "ui/InfoButton";
import ModalWindow from "ui/ModalWindow";

type AttributeDescriptionModalProps = {
  title: string;
  content: string | null;
};

const AttributeDescriptionModal: React.FC<AttributeDescriptionModalProps> = ({
  title,
  content,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!content) return null;

  return (
    <>
      <InfoButton onClick={() => setIsOpen(true)} />
      <ModalWindow
        wrapContent={true}
        title={title}
        content={<MarkdownContent content={content} />}
        isModalOpen={isOpen}
        setIsModalOpen={setIsOpen}
      />
    </>
  );
};

export default AttributeDescriptionModal;
